export const DISABLE_ALL_NETWORK = false;
